import { render } from "./AddParticipantsModal.vue?vue&type=template&id=12a7f55a&scoped=true"
import script from "./AddParticipantsModal.vue?vue&type=script&lang=js"
export * from "./AddParticipantsModal.vue?vue&type=script&lang=js"

import "./AddParticipantsModal.vue?vue&type=style&index=0&id=12a7f55a&lang=scss&scoped=true"
import "./AddParticipantsModal.vue?vue&type=style&index=1&id=12a7f55a&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-12a7f55a"]])

export default __exports__